import { render, staticRenderFns } from "./CChart.vue?vue&type=template&id=6cbb0b08&scoped=true&"
import script from "./CChart.vue?vue&type=script&lang=js&"
export * from "./CChart.vue?vue&type=script&lang=js&"
import style0 from "./CChart.vue?vue&type=style&index=0&id=6cbb0b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbb0b08",
  null
  
)

export default component.exports